import { FC } from 'react';
import { nameof } from '../../utils/stringUtils';
import useTimeFormatters from '../../shared/hooks/useTimeFormatters';
import useElapsedTime from '../../shared/hooks/useElapsedTime';

interface IProps {
  startTimestamp: number;
}

const ElapsedTimeSpan: FC<IProps> = ({ startTimestamp }) => {
  const { formatTimeSpan } = useTimeFormatters();
  const elapsedSeconds = useElapsedTime(startTimestamp);

  return <span style={{ whiteSpace: 'nowrap' }}>{formatTimeSpan(elapsedSeconds)}</span>;
};

ElapsedTimeSpan.displayName = nameof({ ElapsedTimeSpan });
export default ElapsedTimeSpan;